export default __webpack_public_path__ + "static/media/le_neubourg4.437fa927.jpg";